module.exports = __webpack_public_path__ + "images/assets/91f9c53145e16bde9fa2b862821d1b8b.svg";